import { WarningFilled } from '@ant-design/icons';
import Tooltip from 'antd/lib/tooltip';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { rwColors } from '@/components/styles/globalStyles';
import { RootState } from '@/reducers/reducers';
import { selectPilotIsMissingPermissions } from '@/selectors/selectors';

interface PilotMissingPermissionsWarningProps {
    appId: string;
    pilotId: string | null | undefined;
}

export const PilotMissingPermissionsWarning: React.FC<PilotMissingPermissionsWarningProps> = ({ appId, pilotId }) => {
    const isMissingPermissions = useSelector((state: RootState) =>
        selectPilotIsMissingPermissions(state, appId, pilotId),
    );

    if (!isMissingPermissions) {
        return null;
    }

    const message = (
        <>
            This pilot is assigned to the release but missing release pilot permissions.
            <br />
            From <b>Org settings &gt; Team</b>, ensure that they have app access and &apos;Eligible for pilot
            rotation&apos; enabled in assigned group settings.
        </>
    );

    return (
        <Tooltip title={message}>
            <WarningFilled style={{ color: rwColors.statusYellow }} />
        </Tooltip>
    );
};

export default PilotMissingPermissionsWarning;
